export default __webpack_public_path__ + "static/media/icon-lavatory.cdaf7bad.svg";